"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _styles = require("@material-ui/core/styles");
var _administrativo = _interopRequireDefault(require("../../lib/imagens/gifsLoading/administrativo.gif"));
var _analise = _interopRequireDefault(require("../../lib/imagens/gifsLoading/analise.gif"));
var _apac = _interopRequireDefault(require("../../lib/imagens/gifsLoading/apac.gif"));
var _rse = _interopRequireDefault(require("../../lib/imagens/gifsLoading/rse.gif"));
var _conecta = _interopRequireDefault(require("../../lib/imagens/gifsLoading/conecta.gif"));
var _consultorio = _interopRequireDefault(require("../../lib/imagens/gifsLoading/consultorio.gif"));
var _dermato = _interopRequireDefault(require("../../lib/imagens/gifsLoading/dermato.gif"));
var _ecg = _interopRequireDefault(require("../../lib/imagens/gifsLoading/ecg.gif"));
var _educacao = _interopRequireDefault(require("../../lib/imagens/gifsLoading/educacao.gif"));
var _eeg = _interopRequireDefault(require("../../lib/imagens/gifsLoading/eeg.gif"));
var _espiro = _interopRequireDefault(require("../../lib/imagens/gifsLoading/espiro.gif"));
var _estomato = _interopRequireDefault(require("../../lib/imagens/gifsLoading/estomato.gif"));
var _exames = _interopRequireDefault(require("../../lib/imagens/gifsLoading/exames.gif"));
var _mensagens = _interopRequireDefault(require("../../lib/imagens/gifsLoading/mensagens.gif"));
var _oxigenoterapia = _interopRequireDefault(require("../../lib/imagens/gifsLoading/oxigenoterapia.gif"));
var _polissonografia = _interopRequireDefault(require("../../lib/imagens/gifsLoading/polissonografia.gif"));
var _suporte = _interopRequireDefault(require("../../lib/imagens/gifsLoading/suporte.gif"));
var _teleconsultoria = _interopRequireDefault(require("../../lib/imagens/gifsLoading/teleconsultoria.gif"));
var _tfd = _interopRequireDefault(require("../../lib/imagens/gifsLoading/tfd.gif"));
var _tfdpassagens = _interopRequireDefault(require("../../lib/imagens/gifsLoading/tfdpassagens.gif"));
var _buscaativa = _interopRequireDefault(require("../../lib/imagens/gifsLoading/buscaativa.gif"));
var _nexus = _interopRequireDefault(require("../../lib/imagens/gifsLoading/nexus.gif"));
var _dra = _interopRequireDefault(require("../../lib/imagens/gifsLoading/dra.gif"));
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2, 3, 2)
    },
    imagem: {
      width: 40,
      height: 40
    },
    text: {
      marginLeft: theme.spacing(3)
    }
  };
});
function SttLoadingV2(props) {
  var classes = useStyles();
  var open = props.open,
    text = props.text,
    modulo = props.modulo;
  var gifsPorModulo = {
    ADMINISTRATIVO: _administrativo["default"],
    ANALISE: _analise["default"],
    APAC: _apac["default"],
    CONECTA: _conecta["default"],
    CONSULTORIO: _consultorio["default"],
    TELEDERMATO: _dermato["default"],
    ECG: _ecg["default"],
    EDUCACAO: _educacao["default"],
    EEG: _eeg["default"],
    ESPIRO: _espiro["default"],
    ESTOMATO: _estomato["default"],
    EXAMES: _exames["default"],
    MENSAGENS: _mensagens["default"],
    OXIGENOTERAPIA: _oxigenoterapia["default"],
    POLISSONOGRAFIA: _polissonografia["default"],
    SUPORTE: _suporte["default"],
    TELECONSULTORIA: _teleconsultoria["default"],
    TFD: _tfd["default"],
    TFDPASSAGENS: _tfdpassagens["default"],
    RSE: _rse["default"],
    NEXUS: _nexus["default"],
    DRA: _dra["default"],
    BUSCA_ATIVA: _buscaativa["default"]
  };
  var gifSelecionado = gifsPorModulo[modulo === null || modulo === void 0 ? void 0 : modulo.toUpperCase()] || null;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: open
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.paper
  }, gifSelecionado && /*#__PURE__*/_react["default"].createElement("img", {
    src: gifSelecionado,
    className: classes.imagem
  }), text && /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    className: classes.text
  }, text)));
}
SttLoadingV2.propTypes = {
  open: _propTypes["default"].bool,
  text: _propTypes["default"].string,
  modulo: _propTypes["default"].string
};
var _default = SttLoadingV2;
exports["default"] = _default;